// extracted by css-extract-rspack-plugin
export default {"Box":"ChecksStatusBadgeFooter-module__Box__kLp6G"};